module.exports = __webpack_public_path__ + "media/src/assets/img/portrait/small/avatar-s-13-068a2c02188ed79065e518e045bae2da.jpg";